import React from 'react';
import '../css/ApplicationPage.scss';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

const ApplicationPage = () => {
  return (
    <section className="main-container">
      <NavBar />
      <div className="application-section page-width">
        <header className="admission-header">ADMISSION ENQUIRY</header>
        <p className="admission-subheader">Drop your details below and we'll reach out with next steps.</p>
        <form
          className="application-form"
          action="https://formsubmit.co/admin@thehoneyrockacademy.com"
          method="POST"
        >
          <input type="hidden" name="_subject" value="New Admission Enquiry - HoneyRock School" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="table" />

          <div className="form-section">
            <div className="single-input container">
              <label>Parent/Guardian Full Name</label>
              <input type="text" className="input-field" name="guardian_name" required />
            </div>

            <div className="single-input container">
              <label>Email Address</label>
              <input type="email" placeholder="johndoe@gmail.com" className="input-field" name="email" required />
            </div>

            <div className="single-input container">
              <label>Phone Number</label>
              <input type="tel" className="input-field" name="phone_number" required />
            </div>

            <div className="single-input container">
              <label>Child's Name</label>
              <input type="text" className="input-field" name="child_name" />
            </div>

            <div className="single-input container">
              <label>Child's Age / Grade Applying For</label>
              <input type="text" placeholder="Between creche and primary 5" className="input-field" name="child_age_grade" />
            </div>

            <div className="single-input container">
              <label>Message</label>
              <textarea className="input-field" name="message" rows={4} placeholder="Tell us a bit about your child"></textarea>
            </div>
          </div>

          <footer className='form-footer'>We'll respond within 48 hours with next steps and an invitation to visit campus.</footer>
          <div className="submit-button-container">
            <button type="submit" className='submit-button'>
              Submit Enquiry
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </section>
  );
};

export default ApplicationPage;
